import { defineComponent as _defineComponent } from 'vue'
import { useId } from "~/core/composables/useId";
import { toRefs, ref, onMounted, computed, useSlots, useAttrs } from "@nuxtjs/composition-api";

interface Props {
    separator?: string,
    inputCount?: number,
    shouldAutoFocus?: boolean,
    isInputNum?: boolean,
    inputClasses?: string,
    error?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Otp',
  props: {
    separator: { default: '' },
    inputCount: { default: 6 },
    shouldAutoFocus: { type: Boolean, default: true },
    isInputNum: { type: Boolean, default: true },
    inputClasses: { default: '' },
    error: null
  },
  emits: ['handleOnChange', 'handleOnComplete'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { separator: string, inputCount: number, shouldAutoFocus: boolean, isInputNum: boolean, inputClasses: string, error?: string };



const otpInput = ref(null);

const id = useId();
const componentId = computed(() => {
    const attrs = useAttrs();
    return attrs.id ? String(attrs.id) : id;
})



const {
    inputCount,
    separator,
    shouldAutoFocus,
    isInputNum,
    inputClasses,
    error,
} = toRefs(props);

const errorId = computed(() => error.value || useSlots()['error-text'] ? componentId.value + '_error' : undefined);

onMounted(() => {
    const inputs = otpInput.value.$el?.querySelectorAll('input');
    if (inputs && inputs.length) {
        inputs.forEach((input) => {
            input.placeholder = `   `;
        });
    }
})

return { __sfc: true,$emit, otpInput, id, componentId, props, inputCount, separator, shouldAutoFocus, isInputNum, inputClasses, error, errorId }
}

})